module.exports = __webpack_public_path__ + "img/t6.b7d2b7c8.png";